<template>
  <div class="">
    <v-bottom-sheet persistent v-model="visibleCookies">
      <v-sheet class="heightCookies">
        <v-container style="position: inherit">
          <div class="py-5">
            <h1 class="text-h4 font-weight-light">
              {{ $t("login.titleCookes") }}
            </h1>
            <p class="">{{ this.cookie }}</p>
            <v-btn
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              :href="entityConfig.cookiePolicyUrl"
              target="_blank"
              class="float-end m-2 v-btn-width-default"
              >{{ $t("login.masInformacion") }}</v-btn
            >
            <v-btn
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="acceptCookies()"
              class="float-end m-2 v-btn-width-default"
              >{{ $t("login.aceptar") }}</v-btn
            >   
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  props: {
    visibleCookies: {
      default: false,
      type: Boolean,
    },
  },

  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
      this.cookie = this.entityConfig.cookiesText;
    }, 1000);
  },

  data: () => ({
    entityConfig: {},
    cookie: "",
  }),

  methods: {
    acceptCookies() {
      let codNrbeEn = sessionStorage.getItem("codNrbeEn");
      localStorage.setItem("cookies-" + codNrbeEn,
        new Date(new Date().getTime() + 99*24*60*60*1000).getTime()
      );
      this.$emit("accepted");
    },
  },
};
</script>
